import {collectionList} from './BooksWithButton.js';
import {HISTORY, ROR_INDEX, ALFAZAL_INDEX,URDU_BOOKS_INDEX, ENGLISH_BOOKS_INDEX, ARABIC_BOOKS_INDEX, HOLY_QURAN_INDEX, ASK_ISLAM_INDEX, DARSUL_QURAN_INDEX, THIS_WEEK_WITH_HUZOOR_INDEX, BEACON_OF_GUIDANCE_INDEX, ALBADAR_INDEX, ALHAKAM_INDEX,MUSLIM_SUNRISE_INDEX,ALL_TABS_INDEX,FRIDAY_SERMON,FRIDAY_SERMON_ARABIC,AK_DIARIES, GERMAN_BOOKS, AL_REHMAT_INDEX, AL_FURQAN_INDEX, TASHEEZ_UL_AZHAN_INDEX} from '../../backendInfo.js';


const INDEX_LANGUAGE_DEFAULTS = {
    [ROR_INDEX]: 'en',
    [ALFAZAL_INDEX]: 'ur',
    [URDU_BOOKS_INDEX]: 'ur',
    [ENGLISH_BOOKS_INDEX]: 'en',
    [ARABIC_BOOKS_INDEX]: 'ar',
    [FRIDAY_SERMON_ARABIC]: 'ar',
    [GERMAN_BOOKS]: 'de',
    [ALBADAR_INDEX]: 'ur',
    [ALHAKAM_INDEX]: 'ur',
    [MUSLIM_SUNRISE_INDEX]: 'en',
    [FRIDAY_SERMON]: 'en',
    [AK_DIARIES]: 'en',
    [AL_REHMAT_INDEX]: 'ur',
    [AL_FURQAN_INDEX]: 'ur',
    [TASHEEZ_UL_AZHAN_INDEX]: 'ur',
}

const LANGUAGE_ALIASES = {
    ar: 'ar',
    ara: 'ar',
    arabic: 'ar',
    de: 'de',
    deu: 'de',
    ger: 'de',
    german: 'de',
    en: 'en',
    eng: 'en',
    english: 'en',
    ur: 'ur',
    urd: 'ur',
    urdu: 'ur',
}


export const normaliseIndexName = indexName => {
    return indexName ? indexName.replace(/-v\d+$/, '') : indexName
}


export const detailParams = (source, tab, qtype) => {
    let localSource = JSON.parse(JSON.stringify(source))
    // remove unnecessary fields
    delete localSource['text']
    delete localSource['text_diacritics']
    delete localSource['author']
    // Keep author_id for new_urdu_books index
    if (tab !== URDU_BOOKS_INDEX) {
        delete localSource['author_id']
    }
    delete localSource['author_priority']
    delete localSource['summary']
    delete localSource['description']
    // delete localSource['collection']
    delete localSource['collection_priority']
    delete localSource['desc']
    // delete localSource['lang']
    delete localSource['col1']
    delete localSource['col2']
    delete localSource['col3']
    delete localSource['col4']
    delete localSource['col5']
    delete localSource['col6']
    delete localSource['col7']
    delete localSource['col8']
    delete localSource['col9']

    localSource.tab = tab
    localSource.qtype = qtype
    localSource.term = document.querySelector("#search_field").value

    return localSource
}

export const itemInfo = (source, indexName) => {
    if(source.ref_text && source.collection_id !==19 )
        return source.ref_text
    
    let info = ''
    if(indexName === URDU_BOOKS_INDEX){
        if(source.title)
            info += `${source.title}`
        if(source.page_number)
            info += ` Page ${source.page_number}`
        // if(source.collection)
        //     info += source.collection
        // if(source.vol_no && source.vol_no !== null)
        //     info += ` Volume ${source.vol_no}`
        // if(source.other)
        //     info += ` (${source.other})`
        // if(source.year)
        //     info += ` (${source.year})`
        // // if(source.collection_id === 4) //rk
        // //     info += ` (${source.book_name})`    
        // if(source.ref_text && source.collection_id ==19 ){
        //     info += `${source.ref_text}`
        // }
        // if(source.khutba_no) // khm
        //     info += ` \nKhutba #${source.khutba_no}`
        // if(source.khutba_title)
        //     info += ` (${source.khutba_title})`
        // // if(source.collection_id === 55) //tka
        // //     info += ` (PDF Page no. ${source.pdf_pno})`
        // else if(source.page_no)
        //     info += ` Page ${source.page_no}`
        // else if(source.para_no)
        //     info += ` Paragraph ${source.para_no}`
    }
    else if(indexName === ROR_INDEX){
        info += 'Review of Religions'
        if(source.month)
            info += ` ${source.month}`
        if(source.year)
            info += ` ${source.year}`
        if(source.page_no)
            info += ` Page ${source.page_no}`
        if(source.page_no === 0)
            info += ` Table of Contents/Index Page`
    }
    else if(indexName === ALFAZAL_INDEX){
        info += source.ref_text
    }
    else if(indexName === ENGLISH_BOOKS_INDEX){
        if(source.full_title)
            info += `${source.full_title} `
        else if(source.collection)
            info += `${source.collection} `
        info += `Page ${source.page_no}`
    }
    else if( indexName === ARABIC_BOOKS_INDEX){
        if(source.collection)
            info += source.collection
        if(source.vol_no)
            info += ` Volume ${source.vol_no}`
        if(source.book_name)
            info += ` ${source.book_name}`
        if(source.page_no)
            info += ` Page ${source.page_no}`
        if(source.page_no === 0)
            info += ' Preface/Foreword'
    }
    else if(indexName === HOLY_QURAN_INDEX){
        info += `Chapter ${source.chapter}`
        info += ` Verse ${source.verse}`
    }
    else if(indexName === ASK_ISLAM_INDEX){
        info += `Question: ${source.question}`
        info += ` - (${source.date})`
    }
    else if(indexName === DARSUL_QURAN_INDEX){
        info += `${source.title}`
        info += ` - (${source.date})`
    }
    else if([THIS_WEEK_WITH_HUZOOR_INDEX, BEACON_OF_GUIDANCE_INDEX].includes(indexName)){
        info += `${source.title}`
        if(source.start_time)
            info += ` - ${source.start_time.split('.')[0]}`
    }
    else if(indexName === ALBADAR_INDEX){
        info += `Al-Badar Shumara ${source.shumara}`
        info += ` - (${source.year})`
    }
    else if(indexName === ALHAKAM_INDEX){
        info += `Al-Hakam Shumara ${source.shumara}`
        info += ` - (${source.month} ${source.ate}, ${source.year})`
    }
    else if(indexName===MUSLIM_SUNRISE_INDEX){
        // const maxLength = 100;
        // const truncatedTitle = source.title.length > maxLength
        // ? source.title.slice(0, maxLength) + "..."
        // : source.title;
        // info += `Title: ${truncatedTitle}`;
        info+=`${source.title} ${source.year} Issue ${source.issue_no},Page ${source.page_no} `
    }
    else if(indexName === FRIDAY_SERMON){
        info += `${source.title} `
        info += ` ${source.date}`

    }
    else if(indexName === FRIDAY_SERMON_ARABIC){
        // Arabic sermon titles already contain the date -- do not append it again
        info += `${source.title}`

    }
    else if(indexName === AK_DIARIES){
        info += `Abid Khan Sahib's diary ${source.title} `
        info += `Page ${source.page_no}`
    }
    else if(indexName === HISTORY){
        info += `${source.title} `
        info += `Page ${source.page_no}`
    }
   
    else if(indexName === GERMAN_BOOKS){
        info += `${source.title} `
        info += `Page ${source.page_no}`
    }
    else if(indexName === AL_REHMAT_INDEX){
        if(source.title)
            info += `${source.title} `
        if(source.year)
            info += `${source.year} `
        if(source.month)
            info += `Month ${source.month} `
        if(source.page_no)
            info += `Page ${source.page_no}`
    }
    else if(indexName === AL_FURQAN_INDEX){
        if(source.title)
            info += `${source.title} `
        if(source.year)
            info += `${source.year} `
        if(source.month)
            info += `Month ${source.month} `
        if(source.page_no)
            info += `Page ${source.page_no}`
    }
    else if(indexName === TASHEEZ_UL_AZHAN_INDEX){
        if(source.title)
            info += `${source.title} `
        if(source.year)
            info += `${source.year} `
        if(source.jild_no)
            info += `Jild ${source.jild_no} `
        if(source.page_no)
            info += `Page ${source.page_no}`
    }
    else if(indexName === AL_REHMAT_INDEX){
        if(source.title)
            info += `${source.title} `
    
    }
    else if(indexName === AL_FURQAN_INDEX){
        if(source.title)
            info += `${source.title} `
    
    }
    else if(indexName === TASHEEZ_UL_AZHAN_INDEX){
        if(source.title)
            info += `${source.title} `
      
    }
    
    return info
}

export const getDetailItemInfoToggle = (indexName) => {
    const isShow = {
        URDU_BOOKS_INDEX : true,
        ENGLISH_BOOKS_INDEX : true,
        ARABIC_BOOKS_INDEX: true,
        ROR_INDEX : true,
        ALFAZAL_INDEX : true,
        HOLY_QURAN_INDEX : true,
        ASK_ISLAM_INDEX: false, 
        DARSUL_QURAN_INDEX : false,
        [THIS_WEEK_WITH_HUZOOR_INDEX]: false,
        [BEACON_OF_GUIDANCE_INDEX]: false,
        ALBADAR_INDEX : false,
        ALHAKAM_INDEX : false,
        MUSLIM_SUNRISE_INDEX:false,
        FRIDAY_SERMON:false,
        FRIDAY_SERMON_ARABIC:false,
        AK_DIARIES:false,
        AL_REHMAT_INDEX:false,
        AL_FURQAN_INDEX:false,
        TASHEEZ_UL_AZHAN_INDEX:false,

    }

    return isShow[indexName]
}


export const resolveTextLanguage = (lang, indexName) => {
    const normalisedLanguage = String(lang || '').trim().toLowerCase()
    const baseLanguage = normalisedLanguage.split(/[-_]/)[0]
    if (LANGUAGE_ALIASES[normalisedLanguage] || LANGUAGE_ALIASES[baseLanguage]) {
        return LANGUAGE_ALIASES[normalisedLanguage] || LANGUAGE_ALIASES[baseLanguage]
    }

    const normalisedIndex = normaliseIndexName(indexName)
    return INDEX_LANGUAGE_DEFAULTS[normalisedIndex] || 'auto'
}

export const getTextPresentation = (lang, indexName) => {
    const language = resolveTextLanguage(lang, indexName)
    const presentation = {
        ar: { className: 'content-text content-text-arabic', dir: 'rtl', lang: 'ar' },
        de: { className: 'content-text content-text-latin', dir: 'ltr', lang: 'de' },
        en: { className: 'content-text content-text-latin', dir: 'ltr', lang: 'en' },
        ur: { className: 'content-text content-text-urdu', dir: 'rtl', lang: 'ur' },
        auto: { className: 'content-text content-text-auto', dir: 'auto' },
    }
    return { language, ...presentation[language] }
}

export const getTextClass = (lang, indexName) => {
    return getTextPresentation(lang, indexName).className
}

export const showLivePDFButton = (source) => {
    if(source.collection_id === 4)
        return true
    else if (source.collection_id === 'hTee3Wibn7')
        return true
    return false
}

export const showPDFButton = (source, index) => {
   if (index === ARABIC_BOOKS_INDEX){
        return true
    }
    else if (
        index === URDU_BOOKS_INDEX
        && (collectionList.includes(source.collection_id))){
        return true
    }
    else if (index === ROR_INDEX){
        return true
    }
    else if (index === ALFAZAL_INDEX){
        return true
    }
    else if (index=== AK_DIARIES){
        return true
    }
    else if (index=== HISTORY){
        return true
    }
    else if (index=== GERMAN_BOOKS){
        return true
    }
    else if (index === URDU_BOOKS_INDEX){
        return true
    }
    else if (index === ENGLISH_BOOKS_INDEX){
        return true
    }

    return false
}

export const showOpenLinkButton = (queryParams,index) => {
    if (index === ASK_ISLAM_INDEX && queryParams.ask_islam_link){
        return true
    }
    else if (index=== FRIDAY_SERMON ){
        return true
    }
    else if (index=== FRIDAY_SERMON_ARABIC && queryParams.url){
        return true
    }
    return false
}

export const showYoutubeLinkButton = (queryParams,index) => {
    if (index === FRIDAY_SERMON_ARABIC && queryParams.youtube_link){
        return true
    }
    if (index === DARSUL_QURAN_INDEX && queryParams.youtube_link){
        return true
    }
    if ([THIS_WEEK_WITH_HUZOOR_INDEX, BEACON_OF_GUIDANCE_INDEX].includes(index) && (queryParams.timestamp_link || queryParams.youtube_link)){
        return true
    }
    return false
}

export const showAudioBlock = (index) => {
    if (index === ASK_ISLAM_INDEX){
        return true
    }
    return false
}


export const signedUrl = (queryParams) => {
    if (queryParams.tab === URDU_BOOKS_INDEX || queryParams.tab === ENGLISH_BOOKS_INDEX) {
        return 'local_file' in queryParams;
    }
    return (
        [URDU_BOOKS_INDEX, HISTORY, GERMAN_BOOKS, AL_REHMAT_INDEX, AL_FURQAN_INDEX, TASHEEZ_UL_AZHAN_INDEX ].includes(queryParams.tab) &&
        'gcp_book_name' in queryParams
    );
};
